import React, { useState } from "react";
import { message, Form, Input, Select, Button } from "antd";
import PlaceSearch from "./PlaceSearch";
import { controller } from "../controller";
import { useForm } from "antd/es/form/Form";
import { addressLine } from "../lib/placeToAddress";

const { Option } = Select;

// Office.address is a 120-character column.
const OFFICE_ADDRESS_MAX = 120;

// Office "Basic Information" onboarding step (multi-office path). PMS/Sikka
// connection is handled entirely by the dedicated `sikka_setup` step
// (SikkaSetup.js) later in the flow, so this step only captures the office's
// address details.
//
// The address search comes FIRST: picking a place fills every field below it
// (street, city, province, postal code, country) from Google's components. The
// fields stay visible and editable — Google sometimes omits the postal code or
// returns a neighbourhood as the city — so a wrong parse is corrected here
// rather than saved.
const UpdateOffice = (props) => {
  const [form] = useForm();
  const [lat, setLat] = useState("-1");
  const [long, setLong] = useState("-1");
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const myData = {
      ...values,
      latitude: lat,
      longitude: long,
      organization_id: props.practiceId,
    };
    const response = await controller.updateOffice(myData, props.officeId);
    if (response.status < 250) {
      props.readOnboardingStatus();
      message.success("Office information updated!");
    } else {
      message.error(response.detail);
    }
    setLoading(false);
  };

  const onAddress = (a) => {
    if (a.latitude != null) setLat(String(a.latitude));
    if (a.longitude != null) setLong(String(a.longitude));
    form.setFieldsValue({
      address: addressLine(a, OFFICE_ADDRESS_MAX),
      city: a.city,
      state: a.state,
      zip_code: a.postal_code,
      // An unmapped country leaves the current selection for the user to pick.
      ...(a.country ? { country: a.country } : {}),
    });
  };

  return (
    <>
      <p style={{ fontSize: "20px", fontWeight: "500", marginBottom: 37 }}>Basic Information of your Office</p>

      <Form form={form} name="updatePracticeForm" onFinish={onFinish} autoComplete="off">
        <div className="form-container">
          <div className="form-item full-width">
            <div className="input-lable">Find your office address</div>
            <PlaceSearch onAddress={onAddress} placeholder="Start typing your office address…" />
            <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>
              Pick your address from the list and we'll fill in the rest — check it below before submitting.
            </div>
          </div>

          <div className="form-item full-width">
            <div className="input-lable">Street address</div>
            <Form.Item name="address" rules={[{ required: true, message: "Please enter the street address!" }]}>
              <Input placeholder="Street address" maxLength={OFFICE_ADDRESS_MAX} />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">Country</div>
            <Form.Item
              name="country"
              rules={[
                { required: true, message: "Please select a country!" },
                {
                  validator: (_, value) =>
                    ["Canada", "United States of America"].includes(value) ? Promise.resolve() : Promise.reject("Invalid country"),
                },
              ]}
            >
              <Select placeholder="Select a country" style={{ height: 39 }}>
                <Option value="Canada">Canada</Option>
                <Option value="United States of America">United States of America</Option>
              </Select>
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">State / Province</div>
            <Form.Item name="state" rules={[{ required: true, message: "Please enter the state!" }]}>
              <Input placeholder="Enter state" />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">City</div>
            <Form.Item name="city" rules={[{ required: true, message: "Please enter the city!" }]}>
              <Input placeholder="Enter city" />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">Postal Code</div>
            <Form.Item name="zip_code" rules={[{ required: true, message: "Please enter the postal code!" }]}>
              <Input placeholder="Enter postal code" />
            </Form.Item>
          </div>

          <div className="form-item full-width">
            <Form.Item>
              <Button loading={loading} style={{ marginTop: "25px", width: "100%", height: 39 }} type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};

export default UpdateOffice;
